<template>
    <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3.30803e-05 10.5536C-0.00895369 12.8116 1.81425 14.6493 4.07228 14.6583C5.11219 14.6624 6.11462 14.2701 6.87549 13.5613L12.9682 16.3121C12.9259 16.5399 12.9027 16.7708 12.8988 17.0025C12.8916 19.276 14.7288 21.1248 17.0024 21.1321C19.276 21.1393 21.1248 19.302 21.1321 17.0285C21.1393 14.755 19.302 12.9061 17.0284 12.8989C15.6701 12.8946 14.397 13.5607 13.6261 14.679L7.9018 12.0944C8.30839 11.1126 8.30995 10.0099 7.90621 9.02695L13.6226 6.42912C14.9098 8.29079 17.4625 8.75644 19.3242 7.46926C21.1859 6.18207 21.6515 3.62947 20.3643 1.7678C19.0771 -0.0938704 16.5244 -0.559524 14.6627 0.727661C13.554 1.49424 12.8931 2.75694 12.8952 4.10485C12.8989 4.33685 12.9225 4.56807 12.9656 4.79607L6.88868 7.55743C5.24225 6.01145 2.65426 6.09286 1.10825 7.73927C0.39273 8.50131 -0.00384195 9.50835 3.30803e-05 10.5536Z"
            fill="white"
        />
    </svg>
</template>

<script>
export default {
    setup() {
        return {};
    }
};
</script>

<style lang="scss" scoped></style>
